import React, { useCallback, memo } from 'react';
import DateRange, { DateRangeLabel } from '../date-range/DateRange';
import { SelectOption } from '@leasequery/lq.react-component-library';
import { ReportTypeSetting } from '../../../../models/reportTypeSetting';
import ReportSettingPIT from '../ReportSettingPIT';
import * as Styled from '../styled';
import { ReportType, ClientCustomCalendarModel } from '../../../../models';

interface ReportSettingAPProps {
  onChange: (updatedValue: ReportSettingAPState) => void;
  reportSettingState: ReportSettingAPState;
  reportTypeSetting: ReportTypeSetting;
  isAllowPIT: boolean;
  customCalendarSettings?: ClientCustomCalendarModel;
}

export interface ReportSettingAPState {
  from: string;
  to: string;
  isValid: boolean;
  selectedViewBy: SelectOption<string>;
}

function ReportDateSettingAP({
  onChange,
  reportSettingState,
  reportTypeSetting,
  isAllowPIT,
  customCalendarSettings,
}: ReportSettingAPProps): JSX.Element {
  const dateRangeLabel: DateRangeLabel = { Start: 'From', End: 'To' };

  const dateRangeChangeHandler = useCallback(
    (from: string, to: string, isValid: boolean): void => {
      onChange({
        ...reportSettingState,
        from,
        to,
        isValid,
      });
    },
    [onChange, reportSettingState],
  );

  const pitChangeHandler = useCallback(
    (state) => onChange(state as ReportSettingAPState),
    [onChange],
  );

  return (
    <>
      <DateRange
        onChange={dateRangeChangeHandler}
        startDate={reportSettingState.from}
        endDate={reportSettingState.to}
        dateRangeLabel={dateRangeLabel}
        isValidateRangeValue={true}
      />
      {isAllowPIT && (
        <>
          <Styled.Line />
          <ReportSettingPIT
            reportType={ReportType.ap}
            isAllowPIT={isAllowPIT}
            reportSettingState={reportSettingState}
            reportTypeSetting={reportTypeSetting}
            customCalendarSettings={customCalendarSettings}
            onChange={pitChangeHandler}
          />
        </>
      )}
    </>
  );
}

export default memo(ReportDateSettingAP);
